<template>
  <div class="ContentImage" v-if="srcUrl">
    <div class="ContentImage__wrapper" :class="alignment">
      <img class="ContentImage__image" :style="styles" :src="srcUrl" />
      <p class="ContentImage__subscript" v-if="content.subscript" v-html="content.subscript" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentImage',
  props: {
    content : {
      type: Object,
      required: true
    }
  },
  computed: {
    srcUrl() {
      if ( !this.content.src || ! this.content.src.length || this.content.src.length === 0) {
        return false;
      }

      return this.content.src[0].thumbnails.full.url;
    },
    styles() {
      return this.content.styles; 
    },
    alignment() {
      return {
        'ContentImage__wrapper--right' : this.content.align === 'right',
        'ContentImage__wrapper--left' : this.content.align === 'left'
      }
    }
  }
}
</script>

<style lang="scss">

.ContentImage {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  max-width: 100%;
  overflow: hidden;

  &__wrapper {
    display: flex;
    margin: auto;
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
    overflow: hidden;

    &--left {
      margin: 0;
      flex-direction: row;
    }
    &--right {
      margin: 0;
      align-items: flex-end
    }
  } 

  &__image {
    margin-top: 1em;
    max-width: 100%;
    overflow: hidden;
  }

  &__subscript {
    color: #262626;
    font-style: italic;
    font-size: 15px;
    margin: 2px;
    display: inline-block;

    background: #ececec;
    padding: 1em;
    margin-top: 1em;
    margin: 1em;
  }
}
</style>
